// --------------------------------------------------------------
// Created On: 2025-11-12
// Author: Hannah Vaughan
//
// Last Modified: 2025-12-05
// Modified By: Hannah Vaughan
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./DeactivateDevicesHeader.module.scss";

// Header for modifying device activation statuses with Clear All, Import CSV, and Submit buttons.
export default function DeactivateDevicesHeader(props: Props): Component {
  return (
    <div data-test="deactivate-devices-header" className={`${styles.header} px-2`}>
      <div className="row align-items-top">
        <div className="col-6 mb-4 p-4 pb-0">
          <span className={styles.title}>Modify Device Activation Statuses</span>
        </div>
        <div className="col-6 p-4">
          <div className="float-end d-inline-flex flex-row flex-wrap align-items-center">
            <button
              data-test="deactivate-devices-clear-all-button"
              className="btn btn-light float-end m-1"
              type="button"
              disabled={props.disabled}
              onClick={() => props.onClearAll()}
            >
              <span className="d-none d-md-inline">Clear All</span>
              <span className="d-inline d-md-none">Clear</span>
            </button>
            <button
              data-test="deactivate-devices-import-csv-button"
              className="btn btn-light float-end m-1"
              type="button"
              disabled={props.disabled}
              onClick={() => props.onImportCsv()}
            >
              <span className="d-none d-lg-inline">Import CSV</span>
              <span className="d-inline d-lg-none">Import</span>
            </button>
            <button
              data-test="deactivate-devices-submit-button"
              className="btn btn-light float-end m-1"
              type="button"
              disabled={props.disabled || props.deviceCount === 0}
              onClick={() => props.onSubmit()}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

interface Props {
  disabled: boolean;
  deviceCount: number;
  onSubmit: () => void;
  onImportCsv: () => void;
  onClearAll: () => void;
}
